<div class="chip" [ngClass]="{ active: active }">
  {{ text }}
</div>
